export class AccessToken {

    constructor(public accessTokenExpiration: number,
                public access_token: string,
                public expires_in: number,
                public expires_on: string,
                public ext_expires_in: string,
                public id_token: string,
                public refresh_token: string,
                public token_type: string) {
    }

    public static fromJson(json: Object): AccessToken {
        return new AccessToken(
            json['accessTokenExpiration'],
            json['access_token'],
            json['expires_in'],
            json['expires_on'],
            json['ext_expires_in'],
            json['id_token'],
            json['refresh_token'],
            json['token_type']
        );
    }

}
